import React, {useState, Fragment, useCallback, useEffect} from 'react';
import { useForm } from 'react-hook-form';
import { Card, CardBody, CardHeader, Form, FormGroup, Input, Label, Row, Col  } from 'reactstrap';
import { Breadcrumbs, Btn, H4 } from '../../../../AbstractElements';
import DataTable from 'react-data-table-component';
// import { stafftabledata, tableColumns } from '../../../../Data/Staff';
import { staffCategory, stafftableColumns } from '../../../../Data/GeneralSettings';
import { toast } from 'react-toastify';
import SweetAlert from 'sweetalert2';
import RequiredField from '../../../../Constant';
import CommonModal from '../../../Common/Component/CommonModal';
import { CreateStaffCategory, DeleteStaffCategory, StaffCategoryList, UpdateStaffCategory } from '../../../../apiController';
import { roles_permissions } from '../../../../Layout/Sidebar/Menu';


const StaffCategory = () =>{

  const [Large, setLarge] = useState(false);

  const permission = roles_permissions.find(
    (module) => module.module_name === "Staff Category"
  );

  console.warn(permission)

  const [formdata, setFormdata] = useState({});

  const [searchKeyword, setSearchKeyword] = useState('');
  

  const [selectedRows, setSelectedRows] = useState([]);
    const [toggleDelet, setToggleDelet] = useState(false);
    const [data, setData] = useState(staffCategory);
    const [ staffdep, setStaffCategory] = useState([]);


    const {
      register,
      handleSubmit,
      formState: { errors },
      reset,
    } = useForm();

    const LargeModaltoggle = () => {setLarge(!Large);reset({staffcategory:''})};

    const handleEdit = (row) => {
      console.log(row)
      setFormdata({ id: row.id, staffcategory: row.name });
      setLarge(!Large);
      reset({id: row.id,  staffcategory: row.name });
    };

    const staffCategoryList = staffdep.map( (row, ind) =>(
      {
          ind: ind+1,
          id: row.id,
          staffcategory: row.name,
          action: 
          (
              <span>
                  <Btn
                      attrBtn={{
                          style: {width: 60, fontSize: 14, padding: 4 },
                          color: 'success',
                          className: 'btn btn-xs',
                          type: 'button',
                          onClick: () => handleEdit(row)
                      }}
                  >
                      Edit
                  </Btn>
              </span>
          )
      })
    );

     const stafftableColumns = [
      {
          name: '#',
          selector: row => row['ind'],
          sortable: true,
          center: false,
      },
      {
          name: 'Category',
          selector: row => row['staffcategory'],
          sortable: true,
          center: false,
      },
      // {
      //     name: 'Action',
      //     selector: row => row.action,
      //     sortable: false,
      //     center: true,
      // },
  ];

  if (permission?.edit_access) {
    stafftableColumns.push({
      name: "Action",
      selector: (row) => row["action"],
      sortable: false,
      center: true,
    });
  }

    const handleSearchKeyword = (keyword) => {
      setSearchKeyword(keyword);
      // searchMember(keyword);
  };

    const handleRowSelected = useCallback(state => {
        setSelectedRows(state.selectedRows);
    }, []);

    const handleSaveForm = async (data) => {
      const formattedData = {
          name: data.staffcategory,
          id: formdata.id
      };
  
      try {
          if (formdata.id) {
              const response = await UpdateStaffCategory(formattedData);
              if (response.status === true) {
                setStaffCategory(prev => prev.map(item => item.id === formdata.id ? { ...item, name: formattedData.name } : item));
                  toast.success('Updated Successfully!', { position: toast.POSITION.TOP_CENTER });

                  setTimeout(() => {
                    window.location.reload();
                    }, 2000);
              }
          } else {
              const response = await CreateStaffCategory(formattedData);
              if (response.status === true) {
                setStaffCategory(prev => [...prev, response.data]);
                  toast.success('Created Successfully!', { position: toast.POSITION.TOP_CENTER });
              }
          }
          fetchStaffCategory();
          LargeModaltoggle();
      } catch (error) {
          toast.error('An error occurred!', { position: toast.POSITION.TOP_CENTER });
      }
      reset({staffcategory:''})
  };
  
  
  const handleDelete = async () => {
    const result = await SweetAlert.fire({
      title: 'Are you sure you want to delete?',
      cancelButtonText: 'No!',
      confirmButtonText: 'Yes!',
      reverseButtons: true,
      showCancelButton: true,
    });
  
    if (result.isConfirmed) {
      try {
        const selectedIds = selectedRows.map(row => row.id); 
        await Promise.all(selectedIds.map(id => DeleteStaffCategory(id)));
        setStaffCategory(staffdep.filter(item => !selectedIds.includes(item.id)));
        setSelectedRows([]);
        toast.success('Deleted Successfully!', { position: toast.POSITION.TOP_CENTER });
     
      } catch (error) {
        toast.error('An error occurred!', { position: toast.POSITION.TOP_CENTER });
      }
      finally{
        setTimeout(() => {
          window.location.reload();
          }, 1000);
      }
    }
  };


    const fetchStaffCategory = async () => {
      const response = await StaffCategoryList();
      if (response.status === true) {
        setStaffCategory(response.data);
      }
    };
  
    useEffect(()=>{
      fetchStaffCategory()
    },[])
  return (
    <Card>
      <Breadcrumbs mainTitle='Staff Category' parent='Dashboard' title='staffcategory' />
      <CardHeader className='card-no-border'>
        <div className='header-top'>
          <Fragment>
  <div className="search">
    <Form className="theme-form">
      <FormGroup className="form-group">
        <div className="input-group">
          <Input
            className="form-control"
            type="text"
            placeholder="search"
            defaultValue={searchKeyword}
            onChange={(e) => handleSearchKeyword(e.target.value)}
          />
          <div className="input-group-append">
            <span className="input-group-text">
              <i className="fa fa-search"></i>
            </span>
          </div>
        </div>
      </FormGroup>
    </Form>
  </div>
</Fragment>
          <div className='card-header-right-icon'>
            {/* <DropdownCommon dropdownMain={{ className: 'icon-dropdown', direction: 'start' }} options={DailyDropdown} iconName='icon-more-alt' btn={{ tag: 'span' }} /> */}
            <div className='card-header-right-icon'>
            {permission?.create_access && <Btn attrBtn={{ color: 'light-primary', className: 'btn badge-light-primary', onClick: LargeModaltoggle }}>+ Add Staff Category</Btn>}
            <CommonModal isOpen={Large} title={"Staff Category"} toggler={LargeModaltoggle} size="lg" onSave={handleSubmit(handleSaveForm)} formdata={formdata}>
              <Row>
            <Col sm="12">
            <FormGroup className="mb-3">
              <Label htmlFor="fname">{"Staff Category"} <RequiredField/></Label>
              <input className={`form-control ${errors.staffcategory && "is-invalid"}`} id="staffcategory" type="text" name="staffcategory" defaultValue={formdata.staffcategory || ""} {...register("staffcategory", { required: true })} />
              <span className="text-danger">{errors.staffcategory && "Staff Category is required"}</span>
            </FormGroup>
            </Col>
            </Row>
            </CommonModal>
          </div>
          </div>
        </div>
      </CardHeader>
      <CardBody className='pt-0 campaign-table'>
        <div className='recent-table table-responsive currency-table'>
        <Fragment>
        {(selectedRows.length !== 0) &&
                <div className={`d-flex align-items-center justify-content-between bg-light-info p-2`}>
                    <H4 attrH4={{ className: 'text-muted m-0' }}>Delet Selected Data..!</H4>
                    <Btn attrBtn={{ color: 'danger', onClick: () => handleDelete() }}>Delete</Btn>
                </div>
            }
        <DataTable
                data={staffCategoryList}
                columns={stafftableColumns}
                striped={true}
                center={true}
                pagination
                selectableRows = {permission?.delete_access}
                onSelectedRowsChange={handleRowSelected}
                clearSelectedRows={toggleDelet}
            />
            </Fragment>
        </div>
      </CardBody>
    </Card>
  );
}

export default StaffCategory